import React from 'react';
import AccountGroupManagementRouter from './AccountGroupManagementRouter';

export default function AccountGroupManagementPage() {
  return <><AccountGroupManagementRouter /></>;
}
